import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../i18n";
import { getEffectiveDashboardRole } from "../lib/authSession";
import { getPostLoginPath, isAuthenticated } from "../lib/authRoutes";

const NotFoundPage = () => {
  const { t } = useTranslation();

  // Send a signed-in user back to their dashboard, a guest to the landing page.
  const homePath = isAuthenticated()
    ? getPostLoginPath(getEffectiveDashboardRole())
    : "/";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f4f6f7] px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-10 text-center shadow-lg">
        <h1 className="mb-3 text-3xl font-semibold text-[#111111]">
          {t("auth.notFoundTitle")}
        </h1>
        <p className="mb-6 text-[#4b5563]">{t("auth.notFoundBody")}</p>
        <Link
          to={homePath}
          className="inline-flex h-11 items-center justify-center rounded-lg bg-[#111111] px-6 text-white"
        >
          {t("auth.goHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
